import RangePicker from "../../RangePicker";

import useTableStore from "../../../../store/table";

// context
import { useTableId } from "../../../../contexts/TableId";

const DateRangePicker = ({ id }) => {
  const tableId = useTableId();
  const handleFilter = useTableStore(state => state.handleTableFilter);
  const date = useTableStore(state => state.tableFilters[tableId]?.[id]) || {};

  const handleChange = (e, fieldName, queryType, fieldType) => {
    handleFilter(e, tableId, fieldName, queryType, fieldType);
  }

  return (
    <RangePicker id={id} handleChange={handleChange} date={date} />
  )
};

export default DateRangePicker;

